<template>
  <div>
    <MediaImage
      v-bind="image"
      responsive-style="column_half"
      class="pointer-events-none aspect-4/3 w-full"
    />
    <div class="mt-3 text-size-6 text-muted">{{ description }}</div>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphImageFragment } from '#graphql-operations'

const props = defineProps<ParagraphImageFragment>()

defineBlokkli({
  bundle: 'image',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  // This renders the component when the parent is the slider.
  renderFor: {
    parentBundle: 'slider',
  },
})

const description = computed(
  () =>
    props.captionOverride ||
    props.image?.image?.title ||
    props.image?.image?.alt,
)
</script>
